// This composable is used for recognizing certain keystrokes while actively focused on a text-search component.
// It should be able to go up and down the menu, select items, and in some cases delete selections.
import { ref, watch } from 'vue';

const useSelectorSearchNav = ({
  options,
  selection,
  searchQuery,
  selectorMenuIsOpen,
  selectOption,
  removeOption,
}) => {
  const searchNavIdx = ref(0);

  const onSearchNav = (navType) => {
    if (navType === 'up') searchNavIdx.value = (searchNavIdx.value - 1) % options.value.length;
    if (navType === 'down') searchNavIdx.value = (searchNavIdx.value + 1) % options.value.length;
    if (navType === 'select') selectOption(options.value[searchNavIdx.value]);
    if (Array.isArray(selection.value)) { // Delete key stuff only works for multiselects
      if (navType === 'delete') removeOption(selection.value[selection.value.length - 1]);
    }
  };
  watch(selectorMenuIsOpen, (newValue) => {
    if (!newValue) searchNavIdx.value = 0;
  });
  watch(searchQuery, () => {
    searchNavIdx.value = 0;
  });
  return { searchNavIdx, onSearchNav };
};

export default useSelectorSearchNav;
